export default "/890111dfad6266562826aaa0c8b0b6b71032c800/b3dc542ec1b5794376b3d1da54a4e35b.svg";